export const drawerWidth = 240
export const drawerWidthCollapsed = drawerWidth / 4
export const INACTIVE_TIME_PERIOD = 60000

export enum DeviationPriorityId {
  Normal = 1,
  Critical = 2,
}

export enum ProductRequestStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
}

export const Locales = {
  en: { value: 'en', display: 'English' },
  nb: { value: 'nb', display: 'Norwegian' },
} as const

export enum OrderSuggestionType {
  Info = 'Info',
  Warning = 'Warning',
  Critical = 'Critical',
}

export enum AssetDocumentExportFormat {
  Excel = 1,
  Zip = 2,
  Both = 3,
}

export enum DialogContextTypes {
  workshop = 'workshopDialog',
  boat = 'boatDialog',
  workshopCalander = 'workshopCalander',
  intranet = 'intranet',
  administrator = 'administrator',
}

export enum ThemeModes {
  Dark = 'dark',
  Light = 'light',
}

export enum DropItemTypes {
  SectionItem = 'section_item',
  SectionVariable = 'section_variable',
  SectionTemplate = 'section_template',
}

export const ShareTokenTypes = {
  WorkOrder: 'WorkOrder',
  WorkOrderSection: 'WorkOrderSection',
}

export enum ChecklistType {
  Regular = 'Regular',
  Startup = 'Startup',
  Workshop = 'Workshop',
  AdditionalItems = 'AdditionalItems',
  WorkCase = 'WorkCase',
}

export enum RiskAnalysisRiskStatus {
  NotEvaluated = 0,
  Low = 3,
  Moderate = 5,
  High = 6,
}

export enum RiskAnalysisLevelType {
  Probability,
  Consequence,
}

export enum WorkshopUserRole {
  System = 'System',
  Admin = 'Admin',
  Regular = 'Regular',
}

export enum RoleType {
  System = 4,
  Client = 3,
  Crew = 1,
  Regular = 2,
  Workshop = 5,
  Stock = 6,
}

export enum StockUserRole {
  Administrator = 15,
  Regular = 16,
}

export enum WorkshopBoatStatus {
  Pending = 'Pending',
  Planned = 'Planned',
  Open = 'Open',
  Accepted = 'Accepted',
  InProgress = 'InProgress',
  ForApproval = 'ForApproval',
  Completed = 'Completed',
}

export enum WorkshopCaseLogType {
  StatusChange = 'StatusChange',
  ResourceChange = 'ResourceChange',
  StartDateChange = 'StartDateChange',
  EndDateChange = 'EndDateChange',
}

export enum StockProductStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
}
export enum NotificationStatus {
  Unread = 'Unread',
  Read = 'Read',
}

export enum MainVesselType {
  Boat = 'Boat',
  Barge = 'Barge',
}

export enum BuildMaterial {
  Unset = 'Unset',
  Steel = 'Steel',
  Concrete = 'Concrete',
  Aluminium = 'Aluminium',
}

export enum KeyEventType {
  UP,
  DOWN,
}

export enum CalendarEventType {
  Document = 'Document',
  Equipment = 'Equipment',
  Deviation = 'Deviation',
  WorkOrder = 'WorkOrder',
  Service = 'Service',
  Event = 'Event',
  ExerciseOccurence = 'ExerciseOccurence',
}

export enum ServiceRepeatType {
  Unset = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
}

export enum BoatHullType {
  Catamaran = 1,
  SingleHull = 2,
}

export enum VesselType {
  Boat = 'Boat',
  Barge = 'Barge',
}

export enum FileType {
  Image = 'image',
  File = 'file',
}

export enum BoatCounterType {
  Hour = 1,
  Calendar = 2,
  ManualConsumption = 3,
}

export enum ChecklistItemType {
  Title = 'Title',
  Description = 'Description',
  Text = 'Text',
  Number = 'Number',
  Checkbox = 'Checkbox',
  MultilineText = 'MultilineText',
  Media = 'Media',
  Slider = 'Slider',
  DateTime = 'DateTime',
  Counter = 'Counter',
  Refuel = 'Refuel',
  Location = 'Location',
  BoatValues = 'BoatValues',
}

export enum DefaultRoles {
  ClientAdmin = 10,
}

export enum LocationType {
  WorkOrder = 1,
  WorkShop = 2,
  Stock = 3,
}

export enum StockProductTransactionType {
  Add = 1,
  Remove = 2,
}
export enum WorkOrderStatus {
  New = 0,
  Accepted = 1,
  InProgress = 2,
  Done = 3,
}

export enum RoleCategory {
  Admin = 1,
  Resource = 2,
  System = 3,
  Regular = 4,
}

export enum CertificateStatus {
  New = 0,
  Draft = 1,
  Completed = 2,
}

export enum CertificateEditorMode {
  Boat = 0,
  Workshop = 1,
}

export enum WorkshopWorkOrderSection {
  Incoming = 'Incoming',
  Planned = 'Planned',
  Open = 'Open',
  MyWork = 'MyWork',
  History = 'History',
  Users = 'Users',
  ToApprove = 'toApprove',
}

export enum Portal {
  Boat = 1,
  Stock = 2,
  Workshop = 3,
  Administrator = 4,
  SuperUser = 5,
}

export enum WorkCaseTypes {
  overdue = 1,
  dailyOnGoing = 2,
  toApprove = 3,
}

export enum AssetType {
  Boat = 1,
  FixedAsset = 2,
  Vehicle = 3,
  Property = 4,
  NonVessel = 5,
}

export enum FormMode {
  Create = 1,
  Edit = 2,
  Duplicate = 4,
}

export enum WorkOrderWorkType {
  Preventive = 1,
  Corrective = 2,
}

export enum WorkcaseAnalysisClassification {
  MechanicalError = 1,
  Other = 2,
}

export enum WorkOrderPriority {
  High = 1,
  Low = 2,
}

export enum WorkorderType {
  Internal = 'internal',
  External = 'external',
}

export enum WorkorderElementType {
  Document = 1,
  Checklist = 2,
  Equipment = 3,
  Maintenance = 4,
  Deviation = 5,
}

export enum WorkorderSection {
  CHECKLIST = 'CHECKLIST',
  DOCUMENT = 'DOCUMENT',
  MAINTENANCE = 'MAINTENANCE',
  EQUIPMENT = 'EQUIPMENT',
  DEVIATION = 'DEVIATION',
}

export enum WorkcaseFollowupType {
  Note = 1,
  Suggestion = 2,
  Attachment = 3,
  TimePlanned = 4,
}

export enum ButtonType {
  contained = 'contained',
  outlined = 'outlined',
}

export enum WorkcaseFilterType {
  TotalWorkOrders = 1,
  Overdue = 2,
  Status = 3,
  All = 4,
}

export enum WorkshopCaseStatus {
  Pending = 0,
  Accepted = 1,
  InProgress = 2,
  ForApproval = 3,
  Completed = 4,
  Planned = 5,
}

export enum AssetCardWarningType {
  numberOfDeviations = 'numberOfDeviations',
  numberOfDocumentsWithDueDate = 'numberOfDocumentsWithDueDate',
  numberOfMaintancesToday = 'numberOfMaintancesToday',
}

export enum KeyboardButtonAction {
  Enter = 'Enter',
  Escape = 'Escape',
}

export enum DeviationStatusKey {
  Open = 'Åpen',
  InProgress = 'I prosess',
  Closed = 'Lukket',
}

export enum WorkorderDialogMode {
  View = 'view',
  Edit = 'edit',
}

export enum ServiceTriggerType {
  Calendar = 'Calendar',
  Counter = 'Counter',
}

export enum HttpErrorKeys {
  Deviation = 'deviation',
  SubWorkOrders = 'subWorkOrders',
}
export enum EntityType {
  Workcase = 1,
}
export enum ServiceType {
  Counter = 1,
  DateInterval = 2,
  CounterAndDateInterval = 3,
}
export enum UserShiftStatus {
  Active = 1,
  Sick = 2,
}
